import { clearPersistedViewState } from '@/hooks/usePersistedState';
// Security utilities for Underads CRM

export function initSecurityProtection() {
  // 1. Disable right-click context menu
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });

  // 2. Disable common keyboard shortcuts for DevTools and source code
  document.addEventListener('keydown', (e) => {
    // F12 - DevTools
    if (e.key === 'F12') { e.preventDefault(); return false; }
    // Ctrl+Shift+I - DevTools
    if (e.ctrlKey && e.shiftKey && e.key === 'I') { e.preventDefault(); return false; }
    // Ctrl+Shift+J - Console
    if (e.ctrlKey && e.shiftKey && e.key === 'J') { e.preventDefault(); return false; }
    // Ctrl+Shift+C - Element picker
    if (e.ctrlKey && e.shiftKey && e.key === 'C') { e.preventDefault(); return false; }
    // Ctrl+U - View source
    if (e.ctrlKey && e.key === 'u') { e.preventDefault(); return false; }
    // Ctrl+S - Save
    if (e.ctrlKey && e.key === 's') { e.preventDefault(); return false; }
  });

  // 3. Detect DevTools open and logout
  let devtoolsOpen = false;
  const threshold = 160;
  
  const checkDevTools = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    if (widthThreshold || heightThreshold) {
      if (!devtoolsOpen) {
        devtoolsOpen = true;
        console.clear();
        console.log('%cSTOP!', 'color: red; font-size: 50px; font-weight: bold;');
        console.log('%cThis is a browser feature intended for developers. Do not paste any code here.', 'color: #E63946; font-size: 16px;');
      }
    } else {
      devtoolsOpen = false;
    }
  };
  
  setInterval(checkDevTools, 1000);

  // 4. Allow text selection for copy-paste (only disable on specific interactive elements)
  const style = document.createElement('style');
  style.textContent = `
    input, textarea, [contenteditable="true"] { -webkit-user-select: text; -moz-user-select: text; -ms-user-select: text; user-select: text; }
  `;
  document.head.appendChild(style);

  // 5. Clear console on load
  console.clear();
}

// Auto-logout on idle
export function initIdleLogout(timeoutMinutes = 30) {
  let idleTimer;
  
  const resetTimer = () => {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
      const token = localStorage.getItem('token');
      if (token) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        clearPersistedViewState();
        window.location.href = '/login';
      }
    }, timeoutMinutes * 60 * 1000);
  };

  ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'].forEach(event => {
    document.addEventListener(event, resetTimer, { passive: true });
  });

  resetTimer();
}
